"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeMachineConfig = exports.isValidSchedule = exports.hasScheduleOverlap = exports.isValidTimePeriod = exports.emptyMachineConfig = exports.COOLING_TEMPERATURE_MAX = exports.COOLING_TEMPERATURE_MIN = exports.emptyMachine = void 0;
const emptyMachine = () => {
    return {
        machineId: '',
        micronOnlineStatus: false,
        totalPowerConsumption: 0,
        clubId: '',
        onlineTime: new Date(),
        micronMachineId: '',
        machineName: '',
        clubName: '',
    };
};
exports.emptyMachine = emptyMachine;
exports.COOLING_TEMPERATURE_MIN = 2;
exports.COOLING_TEMPERATURE_MAX = 25;
const emptyMachineConfig = () => ({
    cooling: {
        enabled: false,
        temperature: 12,
        timePeriod: { start: '08:00', end: '18:00' },
    },
    lighting: {
        enabled: false,
        timePeriod: { start: '00:00', end: '23:59' },
    },
    screen: {
        enabled: false,
        brightnessLevel: 0,
        timePeriod: { start: '00:00', end: '23:59' },
    },
    audio: {
        muted: true,
        volumeLevels: [{ level: 0, timePeriod: { start: '00:00', end: '23:59' } }],
    },
});
exports.emptyMachineConfig = emptyMachineConfig;
const timeStringToMinutes = (time) => {
    const [h, m] = time.split(':').map(Number);
    return (h || 0) * 60 + (m || 0);
};
const isValidTimePeriod = (period) => {
    if (!period || !period.start || !period.end)
        return false;
    return timeStringToMinutes(period.start) < timeStringToMinutes(period.end);
};
exports.isValidTimePeriod = isValidTimePeriod;
const hasScheduleOverlap = (periods) => {
    const intervals = periods
        .filter(exports.isValidTimePeriod)
        .map((p) => ({
        start: timeStringToMinutes(p.start),
        end: timeStringToMinutes(p.end),
    }))
        .sort((a, b) => a.start - b.start);
    for (let i = 1; i < intervals.length; i++) {
        if (intervals[i].start < intervals[i - 1].end)
            return true;
    }
    return false;
};
exports.hasScheduleOverlap = hasScheduleOverlap;
const isValidSchedule = (periods) => periods.length > 0 &&
    periods.every(exports.isValidTimePeriod) &&
    !(0, exports.hasScheduleOverlap)(periods);
exports.isValidSchedule = isValidSchedule;
const normalizeMachineConfig = (raw) => {
    const d = (0, exports.emptyMachineConfig)();
    if (!raw)
        return d;
    const rawVolumeLevels = raw.audio?.volumeLevels;
    const defaultPeriod = d.audio.volumeLevels[0].timePeriod;
    const sanitizedVolumeLevels = Array.isArray(rawVolumeLevels)
        ? rawVolumeLevels
            .filter((item) => item != null)
            .map((item) => ({
            level: item.level ?? 0,
            timePeriod: item.timePeriod ?? {
                ...defaultPeriod,
            },
        }))
        : [];
    const volumeLevels = sanitizedVolumeLevels.length > 0
        ? sanitizedVolumeLevels
        : d.audio.volumeLevels;
    return {
        cooling: {
            enabled: raw.cooling?.enabled ?? d.cooling.enabled,
            temperature: raw.cooling?.temperature ?? d.cooling.temperature,
            timePeriod: raw.cooling?.timePeriod ??
                d.cooling.timePeriod,
        },
        lighting: {
            enabled: raw.lighting?.enabled ?? d.lighting.enabled,
            timePeriod: raw.lighting?.timePeriod ??
                d.lighting.timePeriod,
        },
        screen: {
            enabled: raw.screen?.enabled ?? d.screen.enabled,
            brightnessLevel: raw.screen?.brightnessLevel ?? d.screen.brightnessLevel,
            timePeriod: raw.screen?.timePeriod ??
                d.screen.timePeriod,
        },
        audio: {
            muted: raw.audio?.muted ?? d.audio.muted,
            volumeLevels,
        },
    };
};
exports.normalizeMachineConfig = normalizeMachineConfig;
